// This file is for functions that aide the map without needing to import the map store
// If your function requires access to the map store, it belongs in the mapStore
import { useSettingStore } from "@/stores/settingStore.js";
import { getContrastTextFromHex } from '@/utils/styleHelpers.js';

export const getAssetGeojson = (location) => {
    const settingStore = useSettingStore();

    const featureList = [];
    const featureJson = {
        type: "geojson",
        data: {
            type: "FeatureCollection",
            features: featureList,
        },
    };
    location?.forEach((feature) => {
        const forecastColor = settingStore.getForecastSeverityColor(feature.forecastData.riskLevel);
        const gaugeColor = settingStore.getGaugeSeverityColor(feature.gaugeData.riskLevel);
        const myFeat = {
            type: "Feature",
            properties: {
                ...feature,
                forecastRiskLevel: feature.hasForecasts ? feature.forecastData.riskLevel : -1,
                color: feature.hasForecasts ? forecastColor : gaugeColor,
                textColor: getContrastTextFromHex(feature.hasForecasts ? forecastColor : gaugeColor),
            },
            geometry: {
                type: "Point",
                coordinates: feature.location.coordinates,
            },
        };
        featureJson.data.features.push(myFeat);
    });
    return featureJson;
};

export const getGaugeGeojson = (location) => {
    const settingStore = useSettingStore();
    const featureList = [];
    const featureJson = {
        type: "geojson",
        data: {
            type: "FeatureCollection",
            features: featureList,
        },
    };

    const riskLevelDict = {};
    settingStore.gaugeLevels.forEach(el => riskLevelDict[el.color] = el.riskLevel);

    location?.forEach((feature) => {
        const myFeat = {
            type: "Feature",
            properties: {
                id: feature.id,
                ...feature.properties,
                riskLevel: feature.properties.con ? riskLevelDict[feature.properties.c] : null,
                textColor: getContrastTextFromHex(feature.properties.c),
                isVirtual: feature.properties.v ? 1 : 0,
            },
            geometry: {
                type: "Point",
                coordinates: feature.geometry.coordinates,
            },
        };
        featureJson.data.features.push(myFeat);
    });
    return featureJson;
};

export const createPopupHtml = (title, popupType) => {
    let popUpHtml = ``;
    if (popupType === 'asset') {
        popUpHtml = `<div class="map-popup-header location-popup q-py-sm q-px-md">${title}</div>`;
    } else if (popupType === 'fire') {
        popUpHtml = `<div class="popup-fire q-pa-sm">Fire: ${title}</div>`;
    } else if(popupType === 'gauge') {
        popUpHtml = `
            <div class="map-popup-header gauge-popup q-pa-sm">
                ${title}
            </div>
        `;
    }
    return popUpHtml;
};

export const customAttribution = `<a target="_blank" href="https://www.foundryspatial.com/" class="q-mr-xs"><img src="/foundryLogo.svg"><a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>`;

export const mapLabelList = ['Continent', 'Archipelago', 'Country', 'State', 'County', 'Capital city', 'City', 'Town', 'Island', 'Village', 'Place', 'Mountain', 'Road', 'Pathway'];
export const mapWaterLabelList = ['Sea labels', 'Lake labels (lines)', 'Lake labels (points)', 'River labels', 'Stream labels', 'Ferry labels'];
